/**
 * What the general-purpose client does with answers it does not like.
 *
 * Refreshing an expired token is not here any more: the client itself does that now, through
 * the one shared refresh every client in the app uses. Two clients each running their own
 * refresh rotated the refresh token underneath each other, which is how deleting a recording
 * came to fail with no Authorization header at all.
 *
 * What is left is the plan limit, which is a real answer rather than a failure: attach the
 * numbers so the calling component can explain it, and re-read usage so every meter in the
 * app catches up at once.
 */
import axios from '../axios.js';
import { refreshAccount } from '@/http/requests/account';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response;

    if (response && response.status === 402) {
      error.planLimit = response.data || {};
      refreshAccount();
    }

    return Promise.reject(error);
  }
);

export default axios;
